import { KeyConstant } from "const";
import { getPermanenceData, getStoreData, storeData, storePermanenceData } from "./storage.utils";
import { HumpUtils } from "utils";

export const handlePersistBranch = (branch, isChangeAccessToken = true) => {
  if (!branch) return;
  const isRemember = getStoreData(KeyConstant.KEY_REMEMBER_KEY);
  let branchOptions = {};
  try {
    if (typeof branch.options === "object" && branch.options !== null) {
      branchOptions = branch.options;
    } else if (typeof branch.options === "string") {
      branchOptions = JSON.parse(branch.options || "{}") || {};
    }
  } catch (e) {
    branchOptions = {};
  }

  storeData(KeyConstant.KEY_BRANCH_ID, branch.id, isRemember);
  storeData(KeyConstant.KEY_BRANCH_NAME, branch.name, isRemember);
  storeData(KeyConstant.KEY_BRANCH_TYPE, branch.type, isRemember);
  storeData(KeyConstant.KEY_CURRENT_DOMAIN, branch.domain, isRemember);
  storeData(KeyConstant.KEY_BRANCH_MODE, branch.branchMode, isRemember);
  storeData(KeyConstant.KEY_LOGIN_MODE, branch.loginMode, isRemember);
  storeData(KeyConstant.KEY_BRANCH_ATTACHMENT, branch.attachmentId, isRemember);
  storePermanenceData(KeyConstant.KEY_BRANCH_INFORMATION, branchOptions?.information, isRemember);
  storeData(KeyConstant.KEY_BRANCH_QR_EXPIRY_TIME, branchOptions?.qr_expiry_time, isRemember);
  storeData(KeyConstant.KEY_TUS_DOMAIN, branchOptions?.tus_domain, isRemember);
  if (isChangeAccessToken && branch.accessToken) storeData(KeyConstant.KEY_ACCESS_TOKEN, branch.accessToken, isRemember);

  // Save permanently for Login page display on next visit
  localStorage.setItem(KeyConstant.KEY_LAST_BRANCH_NAME, branch.name || "");
  localStorage.setItem(KeyConstant.KEY_LAST_BRANCH_ATTACHMENT, branch.attachmentId || "");
};

export const getCurrentBranch = () => {
  const currentBranchId = getStoreData(KeyConstant.KEY_BRANCH_ID);
  const branchList = getStoreData(KeyConstant.KEY_BRANCH_LIST);
  const list = Array.isArray(branchList) ? branchList : [];
  let currentBranch = list.find(item => item && String(item.id) === String(currentBranchId));
  if (!currentBranch && list.length > 0) {
    currentBranch = list[0];
  }
  if (!currentBranch) {
    return { id: currentBranchId, options: {} };
  }
  const branchOptions = getPermanenceData(currentBranch.id || currentBranchId);
  try {
    currentBranch.options = branchOptions ? JSON.parse(branchOptions) : {};
  } catch (error) {
    currentBranch.options = {};
  }
  return currentBranch;
};

export const sortBranchByName = branches => {
  if (!Array.isArray(branches)) return [];
  branches.sort((prev, next) => {
    let prevBranchName = prev?.name?.toLowerCase();
    let nextBranchName = next?.name?.toLowerCase();
    if (prevBranchName < nextBranchName) return -1;
    if (prevBranchName > nextBranchName) return 1;
    return 0;
  });
  return branches;
};

export const handleUpdateBranchList = branch => {
  if (!branch || !branch.id) return;
  branch = HumpUtils.decamelizeKeys(branch);
  const isRemember = getStoreData(KeyConstant.KEY_REMEMBER_KEY);
  const currentBranchList = getStoreData(KeyConstant.KEY_BRANCH_LIST);
  const list = Array.isArray(currentBranchList) ? currentBranchList : [];
  let found = false;
  const newBranchList = list.map(currentBranch => {
    if (String(currentBranch.id) === String(branch.id)) {
      found = true;
      return { ...currentBranch, ...branch };
    }
    return currentBranch;
  });
  if (!found) {
    newBranchList.push(branch);
  }
  storeData(KeyConstant.KEY_BRANCH_LIST, newBranchList, isRemember);
};
